import { signInWithRedirect, signOut } from 'firebase/auth';
import { router } from '@istrugatskiy/mamk-router';
import { auth, get_me, provider } from '../firebase';

const not_found: route = {
    title: 'Not Found',
    component: 'not-found-page',
    load: () => import('../pages/404.page'),
};

const no_auth: route = {
    title: 'Not Authenticated',
    component: 'login-page',
    load: () => import('../pages/login.page'),
};

const routes: route_list = {
    not_found: not_found,
    no_auth: no_auth,
    layout: {
        '/login': {
            title: 'Login',
            component: '[none]',
            icon: 'login',
            special_path: true,
            load: async (redirect) => {
                redirect('/');
                await signInWithRedirect(auth, provider);
            },
        },
        '/404': not_found,
        '/no-auth': no_auth,
        '/': {
            title: 'Play',
            icon: 'play_arrow',
            component: 'play-page',
            require_auth: true,
            load: () => import('../pages/play.page'),
        },
        '/create': {
            title: 'Create Game',
            icon: 'start',
            component: 'create-page',
            require_auth: true,
            load: () => import('../pages/create.page'),
        },
        '/lobby': {
            title: 'Game Lobby',
            icon: 'start',
            component: 'lobby-page',
            require_auth: true,
            load: () => import('../pages/lobby.page'),
        },
        '/logout': {
            title: 'Logout',
            component: '[none]',
            special_path: true,
            icon: 'logout',
            load: async () => {
                await signOut(auth);
                window.location.href = `/${window.location.search}`;
            },
        },
    },
};

/**
 * The global router instance.
 */
const router_instance = new router(
    routes,
    async (user) => {
        if (user === null || user === undefined) return false;
        return (await get_me(user)) !== undefined;
    },
    []
);

export default router_instance;
